/**
 * modifyPlanActions
 *
 * @descirption
 * Re-creates the action branches of an Action Plan, modifier provided is inserted when
 * target location is reached
 */
export function modifyPlanActions<
    A extends { actions: A[]; actionId?: number },
    L extends { actionIndex: number },
>(actions: A[], location: L[], modifier: A[]): A[] {
    if (location.length > 0) {
        return actions.map((act, idx) =>
            idx === location[0].actionIndex
                ? {
                      ...act,
                      ...{
                          actions: modifyPlanActions(
                              act.actions,
                              location.slice(1, location.length),
                              modifier,
                          ),
                      },
                  }
                : act,
        );
    } else {
        return modifier;
    }
}

/**
 * getScopedActions
 *
 * @description
 * Retrieves action group at given location
 */
export function getScopedActions<A extends { actions: A[] }, L extends { actionIndex: number }>(
    apActions: A[],
    location: L[],
): A[] {
    return location.length > 0
        ? getScopedActions(
              apActions[location[0].actionIndex].actions,
              location.slice(1, location.length),
          )
        : apActions;
}

/**
 * getParentAction
 *
 * @description
 * Retrieves parent action of provided action group
 */
export function getParentAction<A extends { actions: A[] }, L extends { actionIndex: number }>(
    apActions: A[],
    location: L[],
): A | null {
    return location.length > 0
        ? getScopedActions(apActions, location.slice(0, -1))[location.slice(-1)[0].actionIndex] ||
              null
        : null;
}
